import { gql } from "@apollo/client";
import useStdQuery from "components/data/hooks/useStdQuery.js";


const GET_REASON_CODE_FEES = gql`
	query ReasonCodeFees (
		$subsystemAccountReference: ID!
		$tokenId: String!
		$reasonCodeId: String!
		$mediaSKU: String!
	){
		reasonCodeFeesQ (
			subsystemAccountReference: $subsystemAccountReference
			tokenId: $tokenId
			reasonCodeId: $reasonCodeId
			mediaSKU: $mediaSKU
		){
			replacementFeeAmount
			replacementFeeOriginalAmount
			chargeReplacementFee
			waiveEnablementFee
			transferEnablement
			netReplacementFeeCalculation
		}
	}
`;

export const useReasonCodeFees = ({
	subsystemAccountReference,
	tokenId,
	reasonCodeId = null,
	mediaSKU,
	skip = false,
}) => {
	const queryResult = useStdQuery(GET_REASON_CODE_FEES, {
		variables: {
			subsystemAccountReference,
			tokenId,
			reasonCodeId,
			mediaSKU,
		},
		// We only want to fire this query if the selected ReasonCode.chargeReplacementFee = true
		skip: skip || !reasonCodeId || !mediaSKU,
	});

	const replacementFeeObj = queryResult?.data?.reasonCodeFeesQ ?? null;

	return {
		replacementFeeObj,
		queryResult,
	};
};
